import React from 'react';
import { Button } from './ui/button';
import { FileDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export default function PDFExportButton() {
  const { language } = useLanguage();

  const handleExportPDF = () => {
    window.open('/print-all', '_blank');
  };

  return (
    <Button
      onClick={handleExportPDF}
      className="bg-gradient-to-r from-fuchsia-500 to-pink-500 hover:from-fuchsia-600 hover:to-pink-600 text-white font-semibold shadow-[0_0_15px_rgba(236,72,153,0.5)] hover:shadow-[0_0_25px_rgba(236,72,153,0.7)] px-2 xl:px-3 py-1.5 text-xs xl:text-sm"
      title={language === 'fr' ? 'Exporter tout le plan en PDF' : 'Export full plan as PDF'}
    >
      <FileDown className="h-3 w-3 xl:h-4 xl:w-4 mr-1" />
      PDF
    </Button>
  );
}
